"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMyPlaces = void 0;
var NearbyResultItemComponent_1 = require("@/pages/detail/components/NearbyResultItemComponent");
var React = require("react");
var NearbyCommuteEstimator_1 = require("@/pages/detail/components/NearbyCommuteEstimator");
exports.renderMyPlaces = function (props) {
    var places = props.nearbyMap.big.savedPlaces;
    var onAddPlaceClick = function () { return props.onAddPlaceClick(); };
    if (props.isNearbyEstimatorShowing) {
        return React.createElement(NearbyCommuteEstimator_1.default, { type: 'sm' });
    }
    if (places && places.length) {
        var renderPlace = function (it, i) {
            var onMyPlaceClick = function () { return props.onMyPlaceClick(it, i); };
            return (React.createElement(NearbyResultItemComponent_1.NearbyResultItemComponent, { key: i, i: i, item: it, t: props.t, backgroundColor: '#085963', iconClass: 'fas fa-star', onResultItemClick: onMyPlaceClick, from: props.lat ? { lat: props.lat, lng: props.lng } : null }));
        };
        return (React.createElement("div", { className: "c-distance-card c-distance-card--active c-distance-card--sm" },
            React.createElement("div", { className: "c-distance-card__filters" },
                React.createElement("div", { className: "c-distance-card__title" }, props.t.results),
                React.createElement("a", { onClick: onAddPlaceClick, className: "o-textbtn" },
                    React.createElement("span", { className: "fas fa-plus" }),
                    props.t.addPlace)),
            places.map(renderPlace)));
    }
    return (React.createElement("div", { className: "c-distance-card__empty c-distance-card__empty--sm" },
        React.createElement("div", { className: "c-distance-card__empty-title" }, props.t.noSavedPlaceYet),
        React.createElement("div", { className: "c-distance-card__empty-caption" }, props.t.startAddingNewPlace),
        React.createElement("div", { className: "c-distance-card__empty-action" },
            React.createElement("a", { onClick: onAddPlaceClick, className: "o-textbtn" },
                React.createElement("span", { className: "fas fa-plus" }),
                " ",
                props.t.addPlace))));
};
